export const SET_SORT = 'query/SET_SORT'
export const SORT_ASC = 'query/ASC'
export const SORT_DESC = 'query/DESC'

export const SET_PAGE = 'query/SET_PAGE'

export const SET_FILTER = 'query/SET_FILTER'



// WEBPACK FOOTER //
// ./state/types/query.js